const form = document.querySelector("form[avcs-active]");

/**
 *  All input validation
 */
const checkBasic = (basicEl) => {
  let valid = false;

  const basicValue = basicEl.value.trim();
  if (isRequired(basicEl)) {
    showError(basicEl, "Ce champ est requis");
  } else if (basicValue == "") {
    showSuccess(basicEl);
    valid = true;
  } else {
    showSuccess(basicEl);
    valid = true;
  }
  return valid;
};

const checkSelect = (selectEl) => {
  let valid = false;

  const selectValue = selectEl.value.trim();
  if (isRequired(selectEl)) {
    showError(selectEl, "Ce champ est requis");
  } else if (selectValue == "") {
    showSuccess(selectEl);
    valid = true;
  } else {
    showSuccess(selectEl);
    valid = true;
  }
  return valid;
};

const checkPostalCode = (postalcodeEl) => {
  let valid = false;
  const postalcode = postalcodeEl.value.trim();
  if (isRequired(postalcodeEl)) {
    showError(postalcodeEl, "Ce champ est requis");
  } else if (postalcode == "") {
    showSuccess(postalcodeEl);
    valid = true;
  } else if (!isPostalCodeValid(postalcode)) {
    showError(
      postalcodeEl,
      "Le code postal " + postalcodeEl.value + " n'a un format valide"
    );
  } else {
    showSuccess(postalcodeEl);
    valid = true;
  }
  return valid;
};

const checkIdentifiant = (identifiantEl) => {
  let valid = false;
  const identifiant = identifiantEl.value.trim();
  const nextElement = identifiantEl.nextElementSibling;
  const label = nextElement.classList.contains("control-label")
    ? nextElement.textContent
    : "";

  if (isRequired(identifiantEl)) {
    showError(identifiantEl, "Le champ " + label + " est requis");
  } else if (identifiant == "") {
    showSuccess(identifiantEl);
    valid = true;
  } else if (!isIdentifiantValid(identifiant)) {
    showError(
      identifiantEl,
      "L'identifiant " + identifiantEl.value + " n'est pas valide."
    );
  } else {
    showSuccess(identifiantEl);
    valid = true;
  }
  return valid;
};

const checkPhone = (phoneEl) => {
  let valid = false;
  const phone = phoneEl.value.trim();
  if (isRequired(phoneEl)) {
    showError(phoneEl, "Ce champ est requis");
  } else if (phone == "") {
    showSuccess(phoneEl);
    valid = true;
  } else if (!isPhoneValid(phone)) {
    showError(phoneEl, "Ce numéro n'est pas valide");
  } else {
    showSuccess(phoneEl);
    valid = true;
  }
  return valid;
};

const checkEmail = (emailEl) => {
  let valid = false;
  const email = emailEl.value.trim();
  const nextElement = emailEl.nextElementSibling;
  const label = nextElement.classList.contains("control-label")
    ? nextElement.textContent
    : "";

  if (isRequired(emailEl)) {
    showError(emailEl, "Le champ " + label + " est requis");
  } else if (email == "") {
    showSuccess(emailEl);
    valid = true;
  } else if (!isEmailValid(email)) {
    showError(
      emailEl,
      "L'adresse de courriel " + emailEl.value + " n'est pas valide."
    );
  } else {
    showSuccess(emailEl);
    valid = true;
  }
  return valid;
};

const checkConfirmEmail = (confirmEmailEl) => {
  let valid = false;
  // check confirm email
  const confirmEmail = confirmEmailEl.value.trim();
  const email = form
    .querySelector(
      '[name="' + confirmEmailEl.getAttribute("avcs-confirm") + '"]'
    )
    .value.trim();
  const nextElement = confirmEmailEl.nextElementSibling;
  const label = nextElement.classList.contains("control-label")
    ? nextElement.textContent
    : "";

  if (isRequired(confirmEmailEl)) {
    showError(confirmEmail, "Le champ " + label + " est requis");
  } else if (confirmEmail == "") {
    showSuccess(confirmEmailEl);
    valid = true;
  } else if (email !== confirmEmail) {
    showError(confirmEmailEl, "Les adresses e-mail ne correspondent pas");
  } else {
    showSuccess(confirmEmailEl);
    valid = true;
  }

  return valid;
};

const checkPassword = (passwordEl) => {
  let valid = false;

  const password = passwordEl.value.trim();
  const nextElement = passwordEl.nextElementSibling;
  const label = nextElement.classList.contains("control-label")
    ? nextElement.textContent
    : "";

  if (isRequired(passwordEl)) {
    showError(passwordEl, "Le champ " + label + " est requis");
  } else if (password == "") {
    showSuccess(passwordEl);
    valid = true;
  } else if (!isPasswordSecure(password)) {
    showError(
      passwordEl,
      "Le mot de passe doit-être composé de 10 caractères minimum dont 1 chiffre, 1 majuscule, 1 minuscule et 1 caractère spécial de la liste suivante !@$^&*"
    );
  } else {
    showSuccess(passwordEl);
    valid = true;
  }

  return valid;
};

const checkConfirmPassword = (confirmPasswordEl) => {
  let valid = false;
  // check confirm password
  const confirmPassword = confirmPasswordEl.value.trim();
  const password = form
    .querySelector('[name="' + confirmPasswordEl.getAttribute("confirm") + '"]')
    .value.trim();
  const nextElement = confirmPasswordEl.nextElementSibling;
  const label = nextElement.classList.contains("control-label")
    ? nextElement.textContent
    : "";

  if (isRequired(confirmPasswordEl)) {
    showError(confirmPasswordEl, "Le champ " + label + " est requis");
  } else if (confirmPassword == "") {
    showSuccess(confirmPasswordEl);
    valid = true;
  } else if (password !== confirmPassword) {
    showError(confirmPasswordEl, "Les mots de passe ne sont pas identiques");
  } else {
    showSuccess(confirmPasswordEl);
    valid = true;
  }

  return valid;
};

/**
 * All functional validation
 */
const isEmailValid = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const isPhoneValid = (phone) => {
  const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  return re.test(phone);
};

const isPasswordSecure = (password) => {
  const re =
    /^(?=[0-9a-zA-Z!@\$\^&\*]{10,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@\$\^&\*])/;
  return re.test(password);
};

const isPostalCodeValid = (postalcode) => {
  const re = /^(?:[0-8]\d|9[0-8])\d{3}$/;
  return re.test(postalcode);
};

const isIdentifiantValid = (identifiant) => {
  const re = /^\d{10}$/;
  return re.test(identifiant);
};

const isRequired = (requiredEl) => {
  let valid = false;
  const value = requiredEl.value.trim();

  if (value === "" && !requiredEl.hasAttribute("avcs-norequired")) valid = true;

  return valid;
};

const isBetween = (length, min, max) =>
  length < min || length > max ? false : true;

/**
 *  show and hide error message
 */
const showError = (input, message) => {
  // get the form-field element
  const formField = input.closest(".js-form-item");
  // add the error class
  formField.classList.remove("success");
  formField.classList.add("has-error");

  // show the error message
  const error = formField.querySelector(".invalid-feedback");

  if (typeof error != "undefined" && error != null) {
    error.textContent = message;
  } else {
    let errorDiv = document.createElement("div");
    errorDiv.classList.add("invalid-feedback");
    let newContent = document.createTextNode(message);
    errorDiv.appendChild(newContent);
    formField.appendChild(errorDiv);
  }

  form.querySelector('button[type="submit"]').disabled = true;
};

const showSuccess = (input) => {
  // get the form-field element
  const formField = input.closest(".js-form-item");

  // remove the error class
  formField.classList.remove("has-error");
  formField.classList.add("success");

  // hide the error message
  const error = formField.querySelector(".invalid-feedback");
  if (typeof error != "undefined" && error != null) error.remove();

  form.querySelector('button[type="submit"]').disabled = false;
};

const debounce = (fn, delay = 500) => {
  let timeoutId;
  return (...args) => {
    // cancel the previous timer
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // setup a new timer
    timeoutId = setTimeout(() => {
      fn.apply(null, args);
    }, delay);
  };
};

if (typeof form != "undefined" && form != null) {
  form.addEventListener(
    "input",
    debounce(function (e) {
      let input = e.target;

      switch (input.getAttribute("avcs-type")) {
        case "basic":
          checkBasic(input);
          break;

        case "postalcode":
          checkPostalCode(input);
          break;

        case "select":
          checkSelect(input);
          break;

        case "phone":
          checkPhone(input);
          break;

        case "identifiant":
          checkIdentifiant(input);
          break;

        case "email":
          checkEmail(input);
          break;

        case "confirm-email":
          checkConfirmEmail(input);
          break;

        case "password":
          checkPassword(input);
          break;

        case "confirm-password":
          checkConfirmPassword(input);
          break;
      }
    })
  );
}

const formClear = () => {
  const observer = new MutationObserver(function (mutations_list) {
    mutations_list.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (added_node) {
        formClear();
        observer.disconnect();
      });
    });
  });

  const form_nas = document.querySelectorAll("form[avcs-na-active]");
  form_nas.forEach((form_na) => {
    form_na.addEventListener(
      "input",
      debounce(function (e) {
        let input = e.target;
        if (input.closest(".tel-area-code--wrapper")) {
          input
            .closest(".tel-area-code--wrapper")
            .querySelectorAll(".has-error")
            .forEach((elem) => {
              elem.classList.remove("has-error");
            });
        } else if (input.closest(".has-error")) {
          input.closest(".has-error").classList.remove("has-error");
        }
      })
    );

    observer.observe(form_na, {
      subtree: false,
      childList: true,
    });
  });
};
// formClear();
